export { default } from './SearchResult'
